<template>
  <div id="app" >
    <HeaderM v-if="HeaderMShow" :class="{show:HeaderMShow}" />

    <!--    <first-Component page="home" v-if="!loader"></first-Component>-->
    <!--    <transition name="el-fade-in">-->
    <!--      <div class="loader-wrap" v-if="loader">-->
    <!--        <img class="logo" v-if="loading" src="../../assets/ablack.png" alt="">-->
    <!--        <div class="loadingbar" v-if="loading">-->
    <!--          <div class="processbar" id="processbar"></div>-->
    <!--        </div>-->
    <!--        <div class="num" id="loadingratio" v-if="loading">0%</div>-->
    <!--      </div>-->
    <!--    </transition>-->
    <div id="page" :class="{menushow:HeaderMShow}">
      <first-Component page="human" @menushow="menushow"></first-Component>
      <div id="scroller-wrapper" data-scrollbar >
        <home-Component></home-Component>
      </div>
    </div>


  </div>
</template>

<script>
  import  {WOW} from 'wowjs'
  import Scrollbar from 'smooth-scrollbar';
  import firstComponent from '@/components/first2.vue'
  import HeaderM from '@/components/Header-m.vue';
  import homeComponent from '@/views/tech.vue'
  import { setTimeout } from 'timers';

  export default {
    name: 'home',
    data(){
      return{
        loader:true,
        loading:false,
        noShow:{},
        wow:'',
        scrollbar:'',
        HeaderMShow: false
      }
    },
    // watch:{
    //   '$route':'init'
    // },
    components:{firstComponent,homeComponent,HeaderM},
    mounted() {
      this.wow=new WOW();
      this.init()
      // this.$nextTick(() => {
      //   setTimeout(()=>{
      //     this.loading=true
      //     this.loadingAddNum(0, 10);
      //   },1000)
      // });
      // this.$router.beforeEach((to, from, next) => {
      //   Scrollbar.destroyAll()
      //   next()
      // })
    },
    methods:{
      menushow(HeaderMShow){
        this.HeaderMShow=HeaderMShow
      },
      loadingAddNum(num, step) {
        setTimeout(() => {
          const processbar = document.getElementById('processbar');
          const loadingratio = document.getElementById('loadingratio');
          processbar.style.width = num + '%';
          loadingratio.innerText = num + '%';

          if (num < 99) {
            let startNum = Math.ceil(num + step);
            if (startNum > 100) {
              startNum = 100;
            }
            this.loadingAddNum(startNum, step);
          } else {
            setTimeout(()=>{
              this.loader=false
              this.wow.init()
            },1000)

          }
        }, 200);
      },
      init(){
        this.$nextTick(()=>{
          this.scrollbar = Scrollbar.init(document.getElementById('scroller-wrapper'));
          this.wow.init()
          this.noShow={display:'block'}
          let scrollbar=Scrollbar.get(document.getElementById('scroller-wrapper'))
          scrollbar.scrollTo(0,0)
          window.pageYOffset=this.scrollbar.scrollTop
          this.scrollbar.addListener(() => {
            this.wow.scrollHandler()
            window.pageYOffset=this.scrollbar.scrollTop
            if(window.pageYOffset>0){
              this.noShow={display:'none'}
            }
          });
        })
      }
    }
  }
</script>
<style>
  a,img,button,input,textarea,div{-webkit-tap-highlight-color:rgba(255,255,255,0);}
  body{
    margin: 0;
    padding: 0;
  }
  ul,li,p,a{
    margin: 0;
    padding: 0;
    text-decoration: none;
    color:black;
  }
  .el-input{
    width:45% !important;
    margin-left:5%;
    margin-top: 30px;
  }
  .el-textarea{
    width:95%;
    margin-left: 5%;
    margin-top: 30px;
  }
  input:focus {
    border-color: #DCDFE6 !important;
    outline: 0;
  }
  textarea:focus{
    border-color: #DCDFE6 !important;
    outline: 0;
    resize: none !important;
  }
  .donghua{
    height:100vh;
    width:100%;
    position: absolute;
    top:0;
    left:0;
    z-index: 999;
    color:white;
    background-color: black;
    animation-duration: 600ms;
    animation-delay: 100ms;
  }
  #app {
    font-family: "Source Sans Pro", Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    width:100%;
    overflow: hidden;
  }
  #page{
    transition: .4s;
    position: relative;
    z-index: 102;
  }
  #page.menushow{
    transform: translate(70%,0);
  }
  #scroller-wrapper{
    position: relative;
    height: 100vh;
    overflow: hidden;
    /* z-index: 101; */
  }
  .scrollbar-thumb{
    width:3px !important;
    background-color: #FECD4A !important;
  }
  .scrollbar-track-y{
    width:3px !important;
  }
  .fade-enter-active{
    /*进入动画*/
    opacity: 0;
    transform: translateX(100%);
  }
  .fade-leave-active{
    /*离开动画*/
    opacity: 0;
    transform: translateX(-100%);
    position: absolute;
  }
  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
</style>
